import _difference from 'lodash/difference';

export function hasSlackAppScopes(currentScopes = null) {
  const requiredScopes = [
    'users:read',
    'channels:read',
    'groups:read',
    'im:read',
    'mpim:read',
  ];

  return (
    currentScopes && _difference(requiredScopes, currentScopes).length === 0
  );
}
